export default {
  EVENT_SETTINGS_UPDATED: "Le impostazioni dell'evento sono state aggiornate con successo!",
  DAILY_REPORTS_ENABLED: 'Report giornalieri abilitati',
  EVENT_SETTINGS: 'Impostazioni evento',
  ARCHIVAL_DAYS: "Giornate d'archivio",
  EVENT_ARCHIVAL_DATE: "L'evento verrà archiviato il "
}
